import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";


export default function useStripe(key, callback) {
	const [value, setValue] = useState(null);

	const load = async () => {
		const v = await loadStripe(key);
		setValue(v);
		callback && callback(v);
	};

	useEffect(() => {
		load();
	}, []);

	return value;
}